
import React from "react";

const FooterSection = () => {
  return (
    <footer className="py-4 px-6 md:px-10 border-t border-gray-200 bg-[#F6F6F7] text-black">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="text-sm text-gray-600">
          ©2025 Disco. All Rights Reserved
        </div>
        
        <div className="flex gap-6 mt-4 md:mt-0">
          <a 
            href="https://www.discoveryconciergeservices.com/terms-conditions" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-gray-900"
          >
            Terms & Conditions
          </a>
          <a 
            href="https://www.discoveryconciergeservices.com/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-gray-900"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
